<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 scrollTableNoTab">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="data" v-if="data.item.status === 'Posted'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:doc_date" slot-scope="row">
                                {{row.item.doc_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:amount" slot-scope="row">
                                {{ row.item.amount | formatMoney }}
                            </template>
                            <template slot="gofix_table:tax" slot-scope="row">
                                {{ row.item.tax | formatMoney }}
                            </template>
                            <template slot="gofix_table:total" slot-scope="row">
                                {{ row.item.total | formatMoney }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'credit-note',
        components: {},
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['credit_note_listing']));
            return {
                tableConfig:{
                    name: 'credit-note-listing',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "doc_no",
                    sortDirection: "desc",
                    useDatabaseView: true,
                    dataSelect: {
                        status: {
                            value: [
                                {value: 'Draft', text: 'Draft'},
                                {value: 'Under Approval', text: 'Under Approval'},
                                {value: 'Approved', text: 'Approved'},
                                {value: 'Rejected', text: 'Rejected'},
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    }
                },
                tableItems: [],
            }
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("CreditNoteController/getPaymentVouchers", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                return this.$router.push(`/v2/credit-note/${item.id}`)
            },
        }
    }
</script>
